export default "__VITE_ASSET__j7cdV7bx__"